<app-menu class="menuApp"></app-menu>
<div class="main">
  <div style="width: 90%; margin: auto;">

    <div class="row" style="padding-top: 3vh">

      <div class="col-6">
        <div class="bodyForm">
          <div class="row rowForm">
            <div class="col">
             <h4 class="textS+">{{this.localiser.get("profile.name")}}</h4>
              <input [(ngModel)]="this.nombre" type="text" class="inputWidth textS" maxlength="25">
            </div>
          </div>
          <div class="row rowForm">
            <div class="col">
              <h4 class="textS+">{{this.localiser.get("profile.surname")}}</h4>
              <input [(ngModel)]="this.apellidos" type="text" class="inputWidth textS" maxlength="40">
            </div>
          </div>
          <div class="row rowForm">
            <div class="col">
              <h4 class="textS+">{{this.localiser.get("profile.email")}}</h4>
              <input [(ngModel)]="this.email" type="text" class="inputWidth textS" maxlength="60">
            </div>
          </div>
          <div class="row rowForm">
            <div class="col">
              <h4 class="textS+">{{this.localiser.get("profile.phone")}}</h4>
              <input [(ngModel)]="this.telefono" type="text" class="inputWidth textS" maxlength="25">
            </div>
          </div>
        </div>

        <div class="col" style="text-align: center; margin-top: 2vh">
          <button class="customButtonColorReverse textS" mat-button (click)="updateUser()">{{this.localiser.get("profile.saveChanges")}}</button>
        </div>


        <div *ngIf="feedbackProfile < 0" class="col errorMessage">
          {{whichProfileMessage()}}
        </div>

        <div *ngIf="feedbackProfile > 0" class="col doneMessage">
          {{whichProfileMessage()}}
        </div>

        <div *ngIf="chargingProfile" class="col">
          <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" diameter="40">
          </mat-progress-spinner>
        </div>

      </div>

      <div class="col-6">
        <div class="bodyForm">
          <div class="row rowForm">
            <div class="col">
              <h4 class="textS+">{{this.localiser.get("profile.oldPassword")}}</h4>
              <input [(ngModel)]="oldPassword" type="password" class="inputWidth textS" maxlength="60">
            </div>
          </div>
          <div class="row rowForm">
            <div class="col">
              <h4 class="textS+">{{this.localiser.get("profile.newPassword1")}}</h4>
              <input [(ngModel)]="newPassword1" type="password" class="inputWidth textS" maxlength="60">
            </div>
          </div>
          <div class="row rowForm">
            <div class="col">
              <h4 class="textS+">{{this.localiser.get("profile.newPassword2")}}</h4>
              <input [(ngModel)]="newPassword2" type="password" class="inputWidth textS" maxlength="60">
            </div>
          </div>
        </div>

        <div class="col" style="text-align: center; margin-top: 2vh">
          <button class="customButtonColorReverse textS" mat-button (click)="updatePassword()">{{this.localiser.get("profile.changePassword")}}</button>
        </div>

        <div *ngIf="feedbackPassword < 0" class="col errorMessage">
          {{whichPasswordMessage()}}
        </div>

        <div *ngIf="feedbackPassword > 0" class="col doneMessage">
          {{whichPasswordMessage()}}
        </div>

        <div *ngIf="chargingPassword" class="col">
          <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" diameter="40">
          </mat-progress-spinner>
        </div>

      </div>

    </div>

  </div>
</div>
